import axios, { AxiosInstance } from "axios";
import { ConcurrencyManager } from "axios-concurrency";
import Cookies from "js-cookie";

// Extend AxiosInstance with custom methods
interface CustomAxiosInstance extends AxiosInstance {
	setAuthToken: (token: string) => void;
	removeAuthToken: () => void;
}

const AxiosCaller = axios.create({
	baseURL: `${process.env.NEXT_PUBLIC_BACKEND_HOST}`,
	headers: {}
}) as CustomAxiosInstance;
// A concurrency parameter of 1 makes all api requests sequential
const MAX_CONCURRENT_REQUESTS = 25;

// init your manager.
ConcurrencyManager(AxiosCaller, MAX_CONCURRENT_REQUESTS);

AxiosCaller.interceptors.response.use(
	(response) => Promise.resolve(response),
	(error) => {
		if (error.response && error.response.status === 401) {
			console.debug("Unauthorized request, token expired. Logging out");
			Cookies.remove("access_token");
			window.location.href = "/login";
		}

		return Promise.reject(error);
	}
);

// Add auth token methods
AxiosCaller.setAuthToken = (token: string) => {
	AxiosCaller.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

AxiosCaller.removeAuthToken = () => {
	delete AxiosCaller.defaults.headers.common["Authorization"];
};

export default AxiosCaller;
